<template>
  <div class="form-page">
    <!-- range-slider years -->
    <div class="form-input-range-years__wrap">
      <div class="form-input-range-years__note-wrap">
        <div class="form-input-range-years__note" id="form-input-range-years__note">2 года</div>
      </div>
      <input class="form-input-range-years" type="range" id="form-input-range-years" value="2" min="1" max="6" step="1">
      <span class="form-input-range-years__min">1 год</span>
      <span class="form-input-range-years__max">6 лет</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Slider',
  props: ['field'],
  data () {
    return {
      msg: 'some text'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/fields/Slider.vue